















































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ProfileTeoNk',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
